import { motion } from "framer-motion";

// Masked, line-by-line reveal for large editorial headings.
export const RevealHeading = ({ lines = [], className = "", delay = 0, testId }) => {
  return (
    <span className={className} data-testid={testId} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden"
          style={{ paddingBottom: "0.08em" }}
          aria-hidden="true"
        >
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.9,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * 0.14,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Scroll-triggered fade/slide reveal wrapper.
export const Reveal = ({ children, className = "", delay = 0, y = 28, testId }) => {
  return (
    <motion.div
      className={className}
      data-testid={testId}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
};
